import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import {
	getHomeserviceApplication,
	getCompletionsAmounts,
	getLoanApplication,
	getLoanInstallment,
	getEscrowApplication,
	getEscrowCompletionsAmounts,
	getMeetgoApplicationInfo,
	getEscrowV2CompletionsAmounts,
} from 'app/api';
import set from 'lodash/set';
import { ENCARPAY_METHOD_PAYMENT_TYPE } from 'app/constants/encarpay';

const CHANGE = 'encarpay/CHANGE';
export const changeAction = createAction(CHANGE);

const SET_AUTHORIZED_APPLICATION_INFO = 'encarpay/SET_AUTHORIZED_APPLICATION_INFO';
export const setAuthorizedApplicationInfoAction = createAction(SET_AUTHORIZED_APPLICATION_INFO);

const GET_HOMESERVICE_APPLICATION = 'encarpay/GET_HOMESERVICE_APPLICATION';
export const getHomeserviceApplicationAction = createAction(GET_HOMESERVICE_APPLICATION, getHomeserviceApplication);

const GET_ESCROW_APPLICATION = 'encarpay/GET_ESCROW_APPLICATION';
export const getEscrowApplicationAction = createAction(GET_ESCROW_APPLICATION, getEscrowApplication);

const GET_MEETGO_APPLICATION = 'encarpay/GET_MEETGO_APPLICATION';
export const getMeetgoApplicationAction = createAction(GET_MEETGO_APPLICATION, getMeetgoApplicationInfo);

const GET_ESCROW_COMPLETIONS_AMOUNTS = 'encarpay/GET_ESCROW_COMPLETIONS_AMOUNTS';
export const getEscrowCompletionsAmountsAction = createAction(GET_ESCROW_COMPLETIONS_AMOUNTS, getEscrowCompletionsAmounts);

const GET_MEETGO_COMPLETIONS_AMOUNTS = 'encarpay/GET_MEETGO_COMPLETIONS_AMOUNTS';
export const getMeetgoCompletionsAmountsAction = createAction(GET_MEETGO_COMPLETIONS_AMOUNTS, getEscrowV2CompletionsAmounts);

const GET_COMPLETIONS_AMOUNTS = 'encarpay/GET_COMPLETIONS_AMOUNTS';
export const getCompletionsAmountsAction = createAction(GET_COMPLETIONS_AMOUNTS, getCompletionsAmounts);

const GET_LOAN_APPLICATIONS = 'encarpay/GET_LOAN_APPLICATIONS';
export const getLoanApplicationAction = createAction(GET_LOAN_APPLICATIONS, getLoanApplication);

const GET_LOAN_INSTALLMENT = 'encarpay/GET_LOAN_INSTALLMENT';
export const getLoanInstallmentAction = createAction(GET_LOAN_INSTALLMENT, getLoanInstallment);

const initialState = {
	authorizedApplication: undefined,
	application: undefined,
	paymentCompleteAmount: undefined,
	loanApplication: undefined,
	loanInstallment: undefined,
	encarpayType: undefined,
	paymentType: ENCARPAY_METHOD_PAYMENT_TYPE.ONCE,
};

export default handleActions(
	{
		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { path, value } = action.payload;

				set(draft, path, value);
			}),
		[SET_AUTHORIZED_APPLICATION_INFO]: (state, action) =>
			produce(state, (draft) => {
				draft.authorizedApplication = action.payload;
				return draft;
			}),

		...pender({
			type: GET_HOMESERVICE_APPLICATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.application = action.payload.data;
					return draft;
				}),
		}),

		...pender({
			type: GET_ESCROW_APPLICATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.application = action.payload.data;
					return draft;
				}),
		}),

		...pender({
			type: GET_MEETGO_APPLICATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.application = action.payload.data;
					return draft;
				}),
		}),

		...pender({
			type: GET_COMPLETIONS_AMOUNTS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.paymentCompleteAmount = action.payload.data.paymentCompleteAmount;
					return draft;
				}),
		}),

		...pender({
			type: GET_ESCROW_COMPLETIONS_AMOUNTS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.paymentCompleteAmount = action.payload.data.paymentCompleteAmount;
					return draft;
				}),
		}),

		...pender({
			type: GET_MEETGO_COMPLETIONS_AMOUNTS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.paymentCompleteAmount = action.payload.data.paymentCompleteAmount;
					return draft;
				}),
		}),

		...pender({
			type: GET_LOAN_APPLICATIONS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.loanApplication = action.payload.data.application;
					return draft;
				}),
		}),

		...pender({
			type: GET_LOAN_INSTALLMENT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.loanInstallment = action.payload.data;
					return draft;
				}),
		}),
	},
	initialState,
);
